import React from 'react'
import styled from 'styled-components'
import ProjectJSON from '../../../project.json'

const FooterComponent = () => {
	const { projectName, type, author, authorURL, year, repo } = ProjectJSON

	return (
		<Footer>
			<p>
				<em>{projectName}</em> is a <span>{type}</span> by{' '}
				<a
					href={authorURL || '#'}
					target="_blank"
					rel="noopener noreferrer"
				>
					{author}
				</a>
				, {year}
			</p>
			{repo && (
				<a href={repo} target="_blank" rel="noopener noreferrer">
					View the source code on GitHub
				</a>
			)}
		</Footer>
	)
}

const Footer = styled.header`
	margin-top: var(--row-gutter);
	color: var(--color-text-secondary);
	font-size: 0.875rem;
	text-align: center;

	& em {
		color: var(--color-font-default);
	}

	& span {
		text-transform: lowercase;
	}
`

export default FooterComponent
